<template>
  <div class="form-group">
    <label class="mb-1" :for="id">{{ label }}</label>
    <input        
        :id="id"
        :name="id"
        :value="modelValue"
        :readonly="readonly"
        :class="[
    'form-control',    
    { 'readonly-field': readonly }
  ]"   
        @input="$emit('update:modelValue', $event.target.value)"
        type="text"
    >
  </div>
</template>

<script>
export default {
  name: "TextField",
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false,
      default: ''
    },
    modelValue: {
      type: String,
      required: false,
      default: ''
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style scoped>
.readonly-field {
  background-color: #e9ecef; 
  color: #6c757d;
  cursor: not-allowed;      
}
</style>
